<template>
  <div>
    <v-container fluid>
      <v-layout>
        <v-flex md12>
          <!-- <material-card v-if="managedServicesList.loadingWorkloads"> -->
          <material-card v-if="(managedServicesList.listType === 'workload' ? true: false )">
            <v-progress-linear
              v-slot:progress
              v-if="managedServicesList.loadingWorkloads"
              color="orange"
              indeterminate/>
            <v-data-table
              :headers="managedServicesList.listWorkloadHeaders"
              :items="filteredWorkloads"
              :pagination.sync="pagination"
              v-model="selected"
              item-key="Project_Id"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr :active="props.selected">
                  <td>
                    <v-checkbox
                      v-model="props.selected"
                      color="orange"
                      hide-details
                    />
                  </td>
                  <td>{{ props.item.Workload_Title }}</td>
                  <td>{{ props.item.OppReg_Req_Date }}</td>
                  <!-- <td>{{ props.item.Workload_Status }}</td> -->
                  <td>
                    <v-tooltip left>
                      <template v-slot:activator="{ on }" >
                        <span v-on="on">{{ props.item.Workload_Status }}</span>
                      </template>
                      <span v-if="props.item.Workload_Status ==='Incomplete/Under Review'">Opportunity is not submitted to AWS. Pending further DXC review</span>
                      <span v-else-if="props.item.Workload_Status === 'Submitted to AWS'">Submitted to AWS for validation</span>
                      <span v-else-if="props.item.Workload_Status === 'Submitted by User'">Opportunity is completed by user and submitted to DXC for review prior to being submitted to AWS</span>
                    </v-tooltip>
                  </td>
                  <td>{{ props.item.Workload_type }}</td>
                </tr>
              </template>
            </v-data-table>
          </material-card>
          <!-- <material-card v-if="(managedServicesList.listType === 'ManagedServices' ? true: false )">
            <v-progress-linear
              v-slot:progress
              v-if="managedServicesList.loadingList"
              color="orange"
              indeterminate/>
            <v-data-table
              :headers="managedServicesList.listHeaders"
              :items="listMngServices"
              v-model="selected"
              hide-actions
              item-key="Managed_Services_Id"
              loading-text="Loading... Please wait"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr :active="props.selected">
                  <td>
                    <v-icon
                      color="orange"
                      class="mr-2"
                      title="View Reequest"
                      @click="editItem(props.item)">
                      visibility
                    </v-icon>
                  </td>
                  <td>{{ props.item.Opportunity_Id }}</td>
                  <td>{{ props.item.AWS_Accounts }} </td>
                  <td>{{ props.item.Description }}</td>
                  <td>{{ props.item.Status }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-progress-linear
              v-slot:progress
              v-if="managedServicesList.loadingList"
              color="orange"
              indeterminate/>
            <div class="text-xs-center mt-3">
              <v-btn :disabled="!managedServicesList.nextPaginationKey || managedServicesList.loadingList" small @click="showNextData">LOAD MORE...</v-btn>
            </div>
          </material-card> -->
        </v-flex> 
      </v-layout>
    </v-container>
  
    <v-dialog large v-model="updateManagedServices.showDialog" persistent scrollable max-width="1300px">
      <v-card>
        <v-card-title class="dialog-title">
          <span>Customer Owned Accounts - Request Managed Svcs</span>
        </v-card-title>
        <v-card-text id="update-dialog-content">
          <v-container
            fluid
            style="padding: 0">
            <v-layout
              row
              wrap>
              <v-flex
                xs12
                sm12
                md12
                xl12>
                <v-container
                  v-if="(currentPage === 'page1')"
                  class="request-details-p1">
                  <v-layout row align-center class="form-row p1">
                    <v-flex
                      md6
                      pt-2
                      class="d-flex align-center">
                      <label>Describe any customization per the SOW that deviates from the standard Gold Managed Services.</label>
                    </v-flex>
                    <v-flex
                      md6>
                      <v-textarea
                        v-model="updateManagedServices.data.Description"
                        placeholder=""
                        name="description"
                        solo
                        readonly
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row align-center class="form-row">
                    <v-flex
                      md6
                      pt-2
                      class="d-flex align-center">
                      <label>List the Client owned AWS Account ID numbers to which the Gold Managed Services need to be deployed. </label>
                    </v-flex>
                    <v-flex
                      md6>
                      <!-- <v-autocomplete
                        v-model="updateManagedServices.data.AWS_Accounts"
                        :items="awsAccountList"
                        item-text="Customer_Name"
                        item-value="Customer_Id"
                        persistent-hint
                        open-on-clear
                        attach
                        multiple
                        chips
                        small-chips
                        solo
                      /> -->
                      <v-text-field
                        v-model="updateManagedServices.data.AWS_Accounts"
                        label="Email"
                        placeholder="Email"
                        solo
                        readonly
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout row align-center class="form-row">
                    <v-flex
                      md6
                      pt-2
                      class="d-flex align-center">
                      <label>List the AWS region(s) where the Gold Managed Services need to be deployed</label>
                    </v-flex>
                    <v-flex
                      md6>
                      <v-autocomplete
                        v-model="updateManagedServices.data.AWS_Regions"
                        :items="managedServicesList.regions"
                        :readonly="updateManagedServices"
                        item-text="label"
                        item-value="value"
                        persistent-hint
                        open-on-clear
                        attach
                        multiple
                        chips
                        small-chips
                        solo
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex md11/>
                    <v-flex md3>
                      <v-btn
                        @click="closeDialog">
                        CLOSE
                      </v-btn>
                      <v-btn
                        class="auto"
                        color="success"
                        @click="continueToNextStep('page2')">
                        CONTINUE
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container v-if="(currentPage === 'page2')" class="request-details-p2">
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md5>
                      <v-text-field
                        :rules="['Valid WBS Code is required']"
                        v-model="awsAccountValidation.wbsCode"
                        :loading="awsAccountValidation.wbsValidating"
                        :success="awsAccountValidation.wbsCodeValidated"
                        :error="!awsAccountValidation.wbsCodeValidated"
                        :messages="awsAccountValidation.wbsValidationMessage"
                        label="Enter WBS Code"
                        outlined
                        @keypress="onWbsChange"
                        readonly
                      >
                        <template v-slot:append>
                          <v-btn
                            :color="awsAccountValidation.wbsCodeValidated ? 'orange' : ''"
                            class="my-0"
                            small
                            @click="onWbsValidate"
                          >
                            <span
                              v-if="!awsAccountValidation.wbsCodeValidated"
                            >validate</span>
                            <v-icon small v-else>check</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 offset-md1 md6>
                      <v-text-field
                        v-model="awsAccountValidation.wbsType"
                        label="WBS Type"
                        placeholder="WBS Type"
                        messages="WBS Type shows here once WBS code is valid"
                        disabled
                        solo
                        readonly
                      />
                    </v-flex>
                    <v-flex xs12 sm6 md5>
                      <v-text-field
                        v-if="awsAccountValidation.wbsType == 'L-CSC-NonUS WBS'"
                        v-model="awsAccountValidation.iwoCode"
                        :loading="awsAccountValidation.iwoValidating"
                        :success="awsAccountValidation.iwoCodeValidated"
                        :error="!awsAccountValidation.iwoCodeValidated"
                        :messages="awsAccountValidation.iwoValidationMessage"
                        label="Enter IWO Code"
                        @keypress="onIwoChange"
                        readonly
                      >
                        <template v-slot:append>
                          <v-btn
                            :color="awsAccountValidation.iwoCodeValidated ? 'orange' : ''"
                            class="my-0"
                            small
                            @click="onIwoValidate"
                          >
                            <span
                              v-if="!awsAccountValidation.iwoCodeValidated"
                            >validate</span>
                            <v-icon small v-else>check</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex md12>
                      <div
                        v-if="awsAccountValidation.wbsCodeValidated"
                        v-bind:class="{ les: awsAccountValidation.wbsType == 'L-ES WBS' }" 
                        class="acknowledged-section mt-3">
                        <p>NOTE: Please ensure that your WBS code is set up with the correct Major Offering codes </p>
                        <p><b>L-ES WBS Codes</b> should be aligned to <b>service line IDATD 6N or ICSEP 6N</b></p>
                        <div 
                          v-if="awsAccountValidation.wbsType == 'L-ES WBS' || awsAccountValidation.wbsType == 'L-CSC-US WBS'"
                          class="wbs-agreement">
                          <p>To validate the major offering code using the following link. The category on the request should be WBS Lookup. <a href='https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx' target="_blank">https://dxcportal.sharepoint.com/sites/operationRequest/Lists/OPS%20Requests/Item/newifs.aspx?Source=https%3a//dxcportal.sharepoint.com/sites/operationRequest/SitePages/Home.aspx</a></p>
                        </div>
                        <div class="iwo-agreement" v-else>
                          <ul>
                            <li>GSAP WBS Codes should be aligned to Offering Portfolio – O_P1322168</li>
                            <li>C1 WBS Codes should be under C1 Profit Center – P1322168</li>
                            <li>To validate the C1 profit center you can look up your WBS under the here: <a href="https://myfrats.csc.com">https://myfrats.csc.com</a></li>
                          </ul>
                          <br />
                        </div>

                        <p> If your WBS Code is set up under any offering other than AWS Cloud Service (I-AWS) please work with your local finance resource to get a code set up under
                        <b>Major Offering Code I-AWS</b></p>
                        <v-checkbox
                          :disabled="!awsAccountValidation.iwoCodeValidated && awsAccountValidation.wbsType == 'L-CSC-NonUS WBS'"
                          v-model="awsAccountValidation.agreed"
                          light
                          class="mx-2 confirm-validation"
                          color="white"
                          label="I understand and have validated that the major offering code is properly selected."
                        />
                      </div>
                    </v-flex>
                    
                  </v-layout>
                  <v-layout>
                    <v-flex
                      md6
                      pt-2
                      class="d-flex align-center">
                      <label>Who is the DXC client account team financial owner of the WBS/IWO?</label>
                    </v-flex>
                    <v-flex
                      md6>
                      <v-text-field
                        v-model="updateManagedServices.data.Client_Email_List"
                        label="Email"
                        placeholder="Email"
                        solo
                        readonly
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex
                      md6
                      pt-2
                      class="d-flex align-center">
                      <label>Who is the DXC account contact to receive the Offering Access code after approvals by DXC AWS Practice?</label>
                    </v-flex>
                    <v-flex
                      md6>
                      <v-text-field
                        v-model="updateManagedServices.data.Offering_Access_Email"
                        label="Email"
                        placeholder="Email"
                        solo
                        readonly
                      />
                    </v-flex>
                  </v-layout>
                  <!-- <v-layout>
                    <v-flex
                      md2
                      pt-2
                      class="d-flex align-center">
                      <label>Account ID</label>
                    </v-flex>
                    <v-flex
                      md4>
                      <v-text-field
                        v-model="updateManagedServices.data.AccountID"
                        label="Account ID"
                        placeholder="Account ID"
                        solo
                        readonly
                      />
                    </v-flex>
                  </v-layout> -->
                  <v-layout>
                    <v-flex
                      md6
                      pt-2
                      class="d-flex align-center">
                      <label>Who is in charge? </label>
                    </v-flex>
                    <v-flex md6 />
                  </v-layout>
                  <v-layout>
                    <v-flex
                      md6>
                      <v-text-field
                        v-model="updateManagedServices.data.InChargeName"
                        label="Name"
                        placeholder="Name"
                        solo
                        readonly
                      />
                    </v-flex>
                    <v-flex
                      md6>
                      <v-text-field
                        v-model="updateManagedServices.data.InChargeEmail"
                        label="Email"
                        placeholder="Email"
                        solo
                        readonly
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout align-end>
                    <v-flex md8/>
                    <v-flex md4>
                      <v-btn
                        @click="closeDialog">
                        CLOSE
                      </v-btn>
                      <v-btn
                        @click="PreviousPage">
                        PREVIOUS PAGE
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      currentPage: 'page1',
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0
      },
      // regions: [
      //   {
      //     label: 'us-east-1 (N. Virginia)',
      //     value: 'us-east-1'
      //   },
      //   {
      //     label: 'us-east-2 (Ohio)',
      //     value: 'us-east-2'
      //   },
      //   {
      //     label: 'us-west-1 (N. California)',
      //     value: 'us-west-1'
      //   },
      //   {
      //     label: 'us-west-2 (Oregon)',
      //     value: 'us-west-2'
      //   },
      //   {
      //     label: 'us-gov-west-1 (US GovCloud West)',
      //     value: 'us-gov-west-1'
      //   },
      //   {
      //     label: 'us-gov-east-1 (US GovCloud East)',
      //     value: 'us-gove-east-1'
      //   },
      //   {
      //     label: 'ca-central-1 (Canada)',
      //     value: 'ca-central-1'
      //   },
      //   {
      //     label: 'eu-north-1 (Stockholm)',
      //     value: 'eu-north-1'
      //   },
      //   {
      //     label: 'eu-west-1 (Ireland)',
      //     value: 'eu-west-1'
      //   },
      //   {
      //     label: 'eu-west-2 (London)',
      //     value: 'eu-west-2'
      //   },
      //   {
      //     label: 'eu-west-3 (Paris)',
      //     value: 'eu-west-3'
      //   },
      //   {
      //     label: 'eu-central-1 (Frankfurt)',
      //     value: 'eu-central-1'
      //   },
      //   {
      //     label: 'eu-south-1 (Milan)',
      //     value: 'eu-south-1'
      //   },
      //   {
      //     label: 'af-south-1 (Cape Town)',
      //     value: 'af-south-1'
      //   },
      //   {
      //     label: 'ap-northeast-1 (Tokyo)',
      //     value: 'ap-northeast-1'
      //   },
      //   {
      //     label: 'ap-northeast-2 (Seoul)',
      //     value: 'ap-northeast-2'
      //   },
      //   {
      //     label: 'ap-northeast-3 (Osaka)',
      //     value: 'ap-northeast-3'
      //   },
      //   {
      //     label: 'ap-southeast-1 (Singapore)',
      //     value: 'ap-southeast-1'
      //   },
      //   {
      //     label: 'ap-southeast-2 (Sydney)',
      //     value: 'ap-southeast-2'
      //   },
      //   {
      //     label: 'ap-east-1 (Hong Kong)',
      //     value: 'ap-east-1'
      //   },
      //   {
      //     label: 'ap-south-1 (Mumbai)',
      //     value: 'ap-south-1'
      //   },
      //   {
      //     label: 'me-south-1 (Bahrain)',
      //     value: 'me-south-1'
      //   },
      //   {
      //     label: 'sa-east-1 (São Paulo)',
      //     value: 'sa-east-1'
      //   },
      //   {
      //     label: 'cn-north-1 (Bejing)',
      //     value: 'cn-north-1'
      //   },
      //   {
      //     label: 'cn-northwest-1 (Ningxia)',
      //     value: 'cn-northwest-1'
      //   },
      //   {
      //     label: 'ap-southeast-3 (Jakarta)',
      //     value: 'ap-southeast-3'
      //   }
      // ]
    }
  },
  computed: {
    ...mapState('user/requestManagedServices', ['managedServicesList', 'sfdcId', 'selectedWorkload', 'loadingWorkloads', 'awsListHeaders', 'workloads', 'workload', 'listManagedServices', 'updateManagedServices', 'awsAccountList', 'awsAccountValidation']),
    filteredWorkloads () {
      console.log('filteredWorkloads', this.managedServicesList.workloads)
      return this.managedServicesList.workloads
    },
    listMngServices () {
      return this.managedServicesList.listManagedServices
    },
    selected: {
      get () {
        console.log('setSelectedWorkload get')
        return this.managedServicesList.selectedWorkload
      },
      set (val) {
        console.log('setSelectedWorkload set', val)
        this.setSelectedWorkload(val)
      }
    }
  },
  methods: {
    onWbsChange () {
      this.newManagedServices.wbsCodeValidated = false
      this.newManagedServices.wbsValidationMessage = ''
    },
    onWbsValidate () {
      this.$store.dispatch('user/requestManagedServices/validateWbsCode', this.awsAccountValidation.wbsCode)
    },
    continueToNextStep (page) {
      this.currentPage = page
    },
    PreviousPage () {
      this.currentPage = 'page1'
    },
    setSelectedWorkload (workload) {
      this.$store.commit('user/requestManagedServices/setSelectedWorkload', workload)
    },
    editItem (item) {
      console.log('editItem', item)
      this.$store.commit('user/requestManagedServices/showUpdateDialog', item)
    },
    closeDialog () {
      this.$store.commit('user/requestManagedServices/closeDialog', true)
    },
    selectedOptions (values) {
      console.log('selectedOptions', values)
      if (Array.isArray(values)) {
        const result = values.map(val => {
          console.log('val', val)
          if (val !== 'None') {
            const item = this.awsAccountList.find(item => item.Customer_Id === val)
            console.log('awsAccountList', item)
            return item ? item.Customer_Name : ''
          } else {
            return ''
          }
        })
        return result
      } else {
        console.log('values', Array.isArray(values))
      }
    },
    showNextData () {
      this.$store.dispatch('user/requestManagedServices/getManagedServices', { nextPaginationKey: this.managedServicesList.nextPaginationKey })
    },
  }
}
</script>
<style lang="scss" scoped>
.dialog-title {
  background-color: black;
  color: white;
  font-size: larger;
}
</style>
